import { Button, Loader } from 'rsuite';
import { useEffect, useState } from 'react';
// import { FlexboxGrid } from 'rsuite';
import { STATUS_CONVERTOR, sortData } from '../../../utils/helpers';

import { Table, Cell, Column, HeaderCell } from 'rsuite-table';
import { handleGetConsultantsRequests } from '../../../api-handler/admin';
import { faIR } from 'date-fns-jalali/locale';
import { format } from 'date-fns-jalali';
import { useNavigate } from 'react-router-dom';

export const AdminRegisterConsultantList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  // const [loading] = useState(false);
  const [sortColumn, setSortColumn] = useState('id');
  const [sortType, setSortType] = useState();
  const [tableLoading, setTableLoading] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // const [defaultData, setDefaultData] = useState<any[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-shadow
  const handleSortColumn = (sortColumn: any, sortType: any) => {
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
  };
  useEffect(() => {
    (async () => {
      setTableLoading(true);
      const res = await handleGetConsultantsRequests();
      if (res.ok) {
        setData(res.data);
      }
      setTableLoading(false);
    })();
  }, []);

  // const [search, setSearch] = useState("");

  // useEffect(() => {
  //   setData(defaultData.filter(d=>(d.Book_Name.toLowerCase().search(search.toLowerCase())>=0)))
  // }, [search]);

  return (
    <>
      <h4 className="text-h4 mb-6">لیست درخواست های نقش مشاور</h4>

      <Table
        data={sortData(data, sortColumn, sortType)}
        sortColumn={sortColumn}
        sortType={sortType}
        onSortColumn={handleSortColumn}
        loading={tableLoading}
        // affixHeader
        renderLoading={() => (
          <div className="flex items-center justify-center h-[100%]">
            <Loader size="md" />
          </div>
        )}
        renderEmpty={() => (
          <div className="flex items-center justify-center h-[100%]">درخواستی موجود نیست</div>
        )}
        autoHeight
        affixHorizontalScrollbar>
        <Column width={100} verticalAlign="middle" align="center">
          <HeaderCell>شماره</HeaderCell>
          <Cell dataKey="ID" />
        </Column>
        <Column flexGrow={1} verticalAlign="middle" align="center">
          <HeaderCell>نام کاربری</HeaderCell>
          <Cell dataKey="Username" />
        </Column>
        <Column flexGrow={1} verticalAlign="middle" align="center">
          <HeaderCell>وضعیت</HeaderCell>
          <Cell dataKey="">
            {(rowData) => {
              return <> {STATUS_CONVERTOR[rowData.Status]}</>;
            }}
          </Cell>
        </Column>
        <Column flexGrow={1} verticalAlign="middle" align="center">
          <HeaderCell>زمان</HeaderCell>
          <Cell dataKey="">
            {(rowData) => {
              return <>{format(rowData.TimeStamp, 'dd MMMM yyyy', { locale: faIR })}</>;
            }}
          </Cell>
        </Column>
        <Column width={90} verticalAlign="middle" align="center">
          <HeaderCell>مشاهده</HeaderCell>
          <Cell dataKey="">
            {(rowData) => (
              <Button
                appearance="primary"
                size="xs"
                type="button"
                onClick={() => navigate(`/admin/register-consultant-single/${rowData.Username}`)}>
                مشاهده
              </Button>
            )}
          </Cell>
        </Column>
      </Table>
    </>
  );
};
